let _ = t => t,
  _t;
import { Fragment } from 'react';
import styled, { ThemeProvider, createGlobalStyle, useTheme } from 'styled-components';
import { Layer } from 'foundations-components/transitional/components/Layer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileLayerGlobalStyle = createGlobalStyle(_t || (_t = _`
  html body {
    overflow: hidden !important;
  }
`));
const StyledMobileLayer = styled.div.withConfig({
  displayName: "MobileLayer__StyledMobileLayer",
  componentId: "cfl3oc-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    position: 'fixed',
    top: 0,
    bottom: 0,
    width: '100vw',
    zIndex: 1211,
    backgroundColor: theme.color['fill-surface-default'],
    overflow: 'scroll'
  };
});
export default function MobileLayer({
  rootNode,
  Transition,
  transitionProps,
  children
}) {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MobileLayerGlobalStyle, {}), /*#__PURE__*/_jsx(ThemeProvider, {
      theme: theme,
      children: /*#__PURE__*/_jsx(Layer, {
        "data-layer-for": "Panel",
        rootNode: rootNode,
        Transition: Transition,
        transitionProps: transitionProps,
        children: /*#__PURE__*/_jsx(StyledMobileLayer, {
          children: children
        })
      })
    })]
  });
}